import { deleteAuthInfo } from '@/utils/helpers'
import { USER_TYPE } from '@/utils/constants'
// import { getFirebaseToken } from '@/utils/firebase'
// import { unregisterFirebaseServiceWorker } from '@/serviceWorker'

export default {
  methods: {
    async logout() {
      deleteAuthInfo()
      window.location.href = `${process.env.VUE_APP_SSO_URL}/logout`
      const url = new URL(`${process.env.VUE_APP_SSO_URL}/logout`)
      url.searchParams.append('origin', window.location.origin)
      url.searchParams.append('platform', USER_TYPE)
      window.location.href = url.href

      // const params = {}
      // let firebaseToken = null
      // try {
      //   firebaseToken = await getFirebaseToken()
      //   if (firebaseToken) {
      //     params.fcm_token = firebaseToken
      //   }
      // } catch (err) {
      //   console.log(err.code)
      //   if (err.code === 'messaging/permission-blocked') {
      //     console.log(
      //       '> Notification permissions could not be revoked because user denied permission'
      //     )
      //   }
      // } finally {
      //   await this.$api.users.logout(params)
      //   if (firebaseToken) {
      //     unregisterFirebaseServiceWorker()
      //   }
      //   deleteAuthInfo()
      //   this.$router.push({
      //     name: 'Login',
      //   })
      // }
    },
  },
}
